import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface RunCanvasArgs extends CanvasArgs {
  /** Client-side delegate that starts the run (WebSocket-coordinated). */
  action?: () => void
}

export class RunCanvasCommand extends CanvasBaseCommand<RunCanvasArgs> {
  readonly id = 'run-canvas'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'play_arrow'
  override label = 'Run'
  override tooltip = 'Run canvas'
  override readonly color = '#4caf50'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override getTooltip(args?: RunCanvasArgs): string {
    if (args?.isRunning) return 'Running...'
    if (args?.isTraceMode) return 'Clear trace to run canvas'
    return 'Run canvas'
  }

  override showSpinner(args?: RunCanvasArgs): boolean {
    return !!args?.isRunning
  }

  override enabled(args?: RunCanvasArgs): boolean {
    return !!args?.canvasId && !args?.isRunning && !args?.isTraceMode && !args?.hasUnsavedChanges
  }

  protected doExecute(args?: RunCanvasArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
